export const ProgressMapIslandTypes = {
    lessons: "lessons",
    contest: "contest",
    enrichment: "enrichment"
}